import React from "react";

function SectionHeading({ titleId, kicker, title, description }) {
  return (
    <div className="primary-section-heading">
      <p className="section-ms-kicker">{kicker}</p>
      <h2 id={titleId}>{title}</h2>
      <div>{description}</div>
    </div>
  );
}

export default SectionHeading;
